import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';

export const StyledContainer = styled('div')(() => {
  return {
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'row',
    gap: '16px',
    padding: '24px',
    backgroundColor: COLORS.white,
    borderRadius: '20px',
    height: '417px',
    maxWidth: '583px',
    boxShadow: '0px 0px 20px 0px #0000000D',
    transition: 'scale 0.3s ease',
    '&:hover': {
      scale: '1.02',
    },
  };
});

export const StyledImageWrapper = styled('div')(() => {
  return {
    width: '230px',
    height: '369px',
    borderRadius: '12px',
  };
});

export const StyledImage = styled('img')(() => {
  return {
    objectFit: 'fill',
    width: '230px',
    height: '369px',
  };
});

export const StyledTextWrapper = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
  };
});

export const StyledTitle = styled('div')(() => {
  return {
    marginBottom: '4px',
  };
});

export const StyledDescription = styled('div')(() => {
  return {
    flex: 1,
  };
});
